export default __webpack_public_path__ + "static/media/background image 1.a005f27b.jpg";